export const formatCurrency = (cents: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(cents / 100);
};

export const calculateCardFee = (amountCents: number): number => {
  return Math.round(amountCents * 0.029 + 30);
};

export const parseLocalDate = (dateStr: string | null | undefined): Date | null => {
  if (!dateStr) return null;
  return new Date(dateStr + 'T00:00:00');
};

export const formatDate = (dateStr: string | null | undefined): string => {
  const date = parseLocalDate(dateStr);
  if (!date) return '';
  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
};

interface InvoiceSummaryItem {
  key: string;
  dueDate?: string | null;
  amount: number;
}

export const separateAndSortInvoices = (invoiceSummary: InvoiceSummaryItem[] = []) => {
  const enrollmentFees = invoiceSummary.filter(inv => inv.key === 'enrollment_fee');
  const tuitionInvoices = invoiceSummary
    .filter(inv => inv.key !== 'enrollment_fee')
    .sort((a, b) => {
      const dateA = a.dueDate ? new Date(a.dueDate + 'T00:00:00') : new Date(0);
      const dateB = b.dueDate ? new Date(b.dueDate + 'T00:00:00') : new Date(0);
      return dateA.getTime() - dateB.getTime();
    });

  const dueNowTotal = enrollmentFees.reduce((sum, inv) => sum + inv.amount, 0);
  const dueLaterTotal = tuitionInvoices.reduce((sum, inv) => sum + inv.amount, 0);

  return {
    enrollmentFees,
    tuitionInvoices,
    dueNowTotal,
    dueLaterTotal
  };
};
